export default class ParallaxElements {

    constructor() {
        this.createElements();
    } 

    createElements() {
        this.els = $(document).find('.parallax-element');

        // Parallax moving elements
        if (this.els.length > 0) {
            // Create parallax.js elements
            this.els.each(function(index, el) {
                let scene = new Parallax(el, {
                    selector: '.parallax-item',
                    pointerEvents: true,
                });
            });
        }

        // Tilt effect
        if ($(document).find('.tiltjs').length > 0) {
            // Create tilt.js elements
            $(document).find('.tiltjs').tilt({
                maxTilt: 10,
                speed: 1000,
                reset: false,
            });
        }
    }
}

//$(document).on('ready', () => { window.ParallaxElements = new ParallaxElements(); });


// WEBPACK FOOTER //
// ./public/js/ParallaxElements.js